/** @format */

// socket.js
import io from "socket.io-client";

const serverUrl = `${process.env.REACT_APP_SERVER_BASE_URL}`;
const socket = io(serverUrl);

export default socket;
